import { Dispatch, SetStateAction } from 'react';
import { CanceledError } from 'axios';
import http from '../shared/HttpCommon';
import { IKeywordSearchResult } from '../shared/interfaces/IKeywordSearchResult';

const getAllSearchResults = async (
  searchHash: string,
  loading: Dispatch<SetStateAction<boolean>>,
  signal: AbortSignal
) => {
  try {
    loading(true);
    const { data } = await http.get(`/keywords/search/${searchHash}`, {
      headers: {
        'Content-Type': 'application/json',
      },
      signal,
    });
    loading(false);
    return data.map((item: any) => {
      return {
        ...item,
        results: item.results.map((result: any) => {
          return {
            ...result,
            original_sentiment_score:
              result.original_sentiment_score === null
                ? 'UNDEFINED'
                : result.original_sentiment_score,
            sentiment_score: result.sentiment_score === null ? 'UNDEFINED' : result.sentiment_score,
          };
        }),
      };
    });
  } catch (error) {
    if (error instanceof CanceledError) {
    } else {
      loading(false);
      console.error(error);
    }
  }
};

const setOverride = async (
  id: string,
  entry: IKeywordSearchResult,
  sentiment: string | null,
  cause: string,
  signal: AbortSignal
) => {
  try {
    let url = `/keywords/${id}/override/${entry.id}`;
    if (cause === 'url') {
      url = `/keywords/overrideurl/${btoa(entry.link)}`;
    }
    const { data } = await http.post(
      url,
      { sentiment: sentiment },
      {
        signal,
      }
    );
    return data;
  } catch (error) {
    if (error instanceof CanceledError) {
    } else {
      console.error(error);
    }
  }
};

const deleteOverride = async (id: string, entry: IKeywordSearchResult, signal: AbortSignal) => {
  try {
    let url = `/keywords/${id}/override/${entry.id}`;
    if (entry.sentiment_overridden_cause === 'url') {
      url = `/keywords/overrideurl/${btoa(entry.link)}`;
    }
    const { data } = await http.delete(url, {
      signal,
    });
    return data;
  } catch (error) {
    if (error instanceof CanceledError) {
    } else {
      console.error(error);
    }
  }
};

const KeywordService = {
  getAllSearchResults,
  setOverride,
  deleteOverride,
};

export default KeywordService;
